export default "__VITE_ASSET__CDD6hbYd__"